// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  color: white;
  min-height: 850px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-gallery-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero-gallery {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  transition: transform 1s ease-in-out;
}

.hero-gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  flex-shrink: 0;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 140, 0, 0.5) 0%, rgba(91, 75, 138, 0.4) 100%);
  z-index: 2;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(30px); }
}

.hero-content {
  position: relative;
  z-index: 10;
  max-width: 900px;
  padding: 40px;
  text-align: center;
  animation: contentSlideIn 1s ease-out;
}

@keyframes contentSlideIn {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero h1 {
  font-size: 3.8em;
  margin-bottom: 75px;
  font-weight: 800;
  line-height: 1.1;
  animation: slideUp 1s ease;
  letter-spacing: -1px;
  font-family: 'Playfair Display', serif;
  margin-top: -100px;
  color: #ffffff;
  -webkit-text-stroke: 0;
  text-stroke: 0;
  text-shadow: none;
}

.hero-content p {
  font-size: 1.2em;
  margin-bottom: 30px;
  text-align: justify;
  line-height: 1.8;
}

.hero h2 {
  font-size: 3.2em;
  margin-bottom: 30px;
  font-weight: 300;
  font-style: italic;
  animation: slideUp 1s ease 0.15s backwards;
  font-family: 'Lora', serif;
  letter-spacing: 3px;
}

.hero p {
  font-size: 1.5em;
  margin-bottom: 50px;
  opacity: 0.98;
  animation: slideUp 1s ease 0.3s backwards;
  line-height: 1.8;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.btn-large {
  font-size: 1.15em;
  padding: 18px 55px;
  animation: slideUp 0.8s ease 0.45s backwards;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.frase-mentor {
  margin-top: 130px;
  padding: 20px 30px;
  background: rgba(255, 255, 255, 0.95);
  border-left: 5px solid #FF8C00;
  border-radius: 8px;
  animation: slideUp 0.5s ease;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.frase-mentor p {
  color: #5B4B8A;
  font-size: 1.15em;
  line-height: 1.6;
  margin: 0;
  font-weight: 500;
  font-family: 'Playfair Display', serif;
}

@media (max-width: 768px) {
  .hero {
    padding: 120px 20px;
    min-height: 500px;
  }

  .hero h1 {
    font-size: 2.2em;
  }

  .hero h2 {
    font-size: 1.8em;
  }

  .hero p {
    font-size: 1.15em;
  }

  .frase-mentor {
    margin-top: 125px;
    padding: 18px 25px;
    font-size: 1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2FAA2F;EAC3F,UAAU;AACZ;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;AACF","sourcesContent":[".hero {\r\n  position: relative;\r\n  color: white;\r\n  min-height: 850px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.hero-gallery-wrapper {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.hero-gallery {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  transition: transform 1s ease-in-out;\r\n}\r\n\r\n.hero-gallery-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.hero-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, rgba(255, 140, 0, 0.5) 0%, rgba(91, 75, 138, 0.4) 100%);\r\n  z-index: 2;\r\n}\r\n\r\n@keyframes float {\r\n  0%, 100% { transform: translateY(0px); }\r\n  50% { transform: translateY(30px); }\r\n}\r\n\r\n.hero-content {\r\n  position: relative;\r\n  z-index: 10;\r\n  max-width: 900px;\r\n  padding: 40px;\r\n  text-align: center;\r\n  animation: contentSlideIn 1s ease-out;\r\n}\r\n\r\n@keyframes contentSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(60px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.hero h1 {\r\n  font-size: 3.8em;\r\n  margin-bottom: 75px;\r\n  font-weight: 800;\r\n  line-height: 1.1;\r\n  animation: slideUp 1s ease;\r\n  letter-spacing: -1px;\r\n  font-family: 'Playfair Display', serif;\r\n  margin-top: -100px;\r\n  color: #ffffff;\r\n  -webkit-text-stroke: 0;\r\n  text-stroke: 0;\r\n  text-shadow: none;\r\n}\r\n\r\n.hero-content p {\r\n  font-size: 1.2em;\r\n  margin-bottom: 30px;\r\n  text-align: justify;\r\n  line-height: 1.8;\r\n}\r\n\r\n.hero h2 {\r\n  font-size: 3.2em;\r\n  margin-bottom: 30px;\r\n  font-weight: 300;\r\n  font-style: italic;\r\n  animation: slideUp 1s ease 0.15s backwards;\r\n  font-family: 'Lora', serif;\r\n  letter-spacing: 3px;\r\n}\r\n\r\n.hero p {\r\n  font-size: 1.5em;\r\n  margin-bottom: 50px;\r\n  opacity: 0.98;\r\n  animation: slideUp 1s ease 0.3s backwards;\r\n  line-height: 1.8;\r\n  font-weight: 400;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.btn-large {\r\n  font-size: 1.15em;\r\n  padding: 18px 55px;\r\n  animation: slideUp 0.8s ease 0.45s backwards;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(40px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.frase-mentor {\r\n  margin-top: 130px;\r\n  padding: 20px 30px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-left: 5px solid #FF8C00;\r\n  border-radius: 8px;\r\n  animation: slideUp 0.5s ease;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\r\n  max-width: 600px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.frase-mentor p {\r\n  color: #5B4B8A;\r\n  font-size: 1.15em;\r\n  line-height: 1.6;\r\n  margin: 0;\r\n  font-weight: 500;\r\n  font-family: 'Playfair Display', serif;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .hero {\r\n    padding: 120px 20px;\r\n    min-height: 500px;\r\n  }\r\n\r\n  .hero h1 {\r\n    font-size: 2.2em;\r\n  }\r\n\r\n  .hero h2 {\r\n    font-size: 1.8em;\r\n  }\r\n\r\n  .hero p {\r\n    font-size: 1.15em;\r\n  }\r\n\r\n  .frase-mentor {\r\n    margin-top: 125px;\r\n    padding: 18px 25px;\r\n    font-size: 1em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
